// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"233":"5cde7d1c","787":"6d5a3c75","852":"ffcfc359"}[chunkId] + ".chunk.js";
};